import React from "react";
const WIDTH: Record<string, string> = {
    lg: "max-w-5xl",
    xl: "max-w-6xl",
    "2xl": "max-w-7xl",
    full: "max-w-none",
};
export default function PageShell({ children, className = "", width = "full", spacing = "md", as: As = "div", }: {
    children?: React.ReactNode;
    className?: string;
    width?: keyof typeof WIDTH;
    spacing?: "sm" | "md" | "lg";
    as?: React.ElementType;
} & Record<string, unknown>): any {
    const spacingClass = spacing === "lg" ? "space-y-8" : spacing === "sm" ? "space-y-4" : "space-y-6";
    return (<As className={`w-full ${WIDTH[width] || WIDTH["2xl"]} ${spacingClass} ${className}`}>
      {children}
    </As>);
}
